<template>
  <el-dialog :visible.sync="dialogShow" width="900px" append-to-body :close-on-click-modal="false">
    <div slot="title" class="font-lg">授权</div>
    <div slot="default" class="pl-lg pr-lg">
      <el-steps class="mb-md" :active="currentStep" finish-status="success" process-status="success" simple>
        <el-step title="选择权限" />
        <el-step title="授权处理" />
      </el-steps>
      <template v-if="currentStep === 0">
        <el-alert type="blue" :closable="false">
          <div slot="title" class="alert">
            <i class="el-icon-warning-outline text-blue mr-sm"></i><div>即将为 {{ authList.length }} 台设备设置以下权限</div>
          </div>
        </el-alert>
        <div class="auth-form">
          <span class="form-label">权限</span>
          <el-select v-model="authValue">
            <el-option v-for="item in authArr" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </div>
      </template>
      <template v-else>
        <div v-if="resSuccess" class="auth-status font-lg mb">授权完成！成功 <span class="text-success">{{ successCount }}</span> 台，失败 <span class="text-danger">{{ list.length - successCount }}</span> 台</div>
        <div v-else class="font-lg text-success mb">正在为下列 {{ authList.length }} 台设备授权</div>
        <el-table :data="list" style="min-height: 260px">
          <el-table-column type="index" width="50" />
          <el-table-column label="go码" prop="go" />
          <el-table-column label="权限">
            <template slot-scope="scope">
              {{ currentAuth }}
            </template>
          </el-table-column>
          <el-table-column label="结果">
            <template slot-scope="scope">
              <span v-if="scope.row.result === 'loading'" class="text-warning">授权中...</span>
              <span v-else-if="scope.row.result === 'success'" class="text-success">成功</span>
              <span v-else class="text-danger">失败，{{ scope.row.result }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div slot="footer" class="text-center">
      <template v-if="currentStep === 0">
        <el-button @click="dialogShow = false">取消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </template>
      <template v-else>
        <el-button v-if="resSuccess" @click="closeDialog">关闭</el-button>
        <div v-else class="loading-text text-warning">正在授权中，已完成 {{ successCount }} / {{ list.length }}<i class="el-icon-loading"></i></div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { updateEquipMemberAuthApi2 } from "@/api/rms/rmsEquipAuthApi";

export default {
  name: "AuthorizationDialog",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    memberid: null,
    authList: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      currentStep: 0,
      authValue: 1,
      list: [],
      successCount: 0,
      resSuccess: false
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    },
    authArr() {
      return this.$store.state.rmsStore.authArr.filter(item => item.value !== 0 && item.value !== 10);
    },
    currentAuth() {
      return this.$store.getters.authObj[this.authValue].title
    }
  },
  methods: {
    submit() {
      this.currentStep = 1
      this.list = this.authList.map(item => {
        return {
          auth: this.currentAuth,
          result: 'loading',
          ...item
        }
      })
      this.authorizedEquip()
    },

    async authorizedEquip() {
      if (this.list.length) {
        for (let i = 0; i < this.list.length; i++) {
          const equip = this.list[i]
          try {
            const res = await updateEquipMemberAuthApi2({
              equipid: equip.equipid,
              bind_type: "member",
              binderid: this.memberid,
              auth_level: this.authValue
            })
            if (res.errno) {
              equip.result = res.message
              continue
            }
            equip.result = 'success'
            this.successCount++

          } catch (error) {
            console.log(error)
            equip.result = '请求超时'
          }

        }
        this.resSuccess = true
      }
    },

    closeDialog() {
      this.dialogShow = false
      this.$emit('multipleAuthSuccess')
    }
  }
}
</script>

<style scoped lang="scss">
.el-alert--blue.is-light {
  background-color: rgba(64,158,255,0.1);
  /deep/ .el-alert__icon {
    color: #409eff;
  }
}
/deep/ .el-alert__content {
  .el-alert__title {
    display: inline-flex;
    align-items: center;
    .alert {
      display: inline-flex;
      align-items: center;
      color: #101010;
      line-height: 19px;

      i {
        font-size: 16px;
      }
    }
  }
}

.auth-form {
  margin-top: 50px;
  margin-bottom: 150px;
  text-align: center;

  .form-label {
    margin-right: 50px;
  }
}

.auth-status {
  color: #303133;
}

.loading-text {
  font-size: 18px;
  height: 36px;
}
</style>
